/* #69: タグを主、時刻を従として扱う。購入可否を時計で書き換えない。 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.NKState = api;
    api.init(root);
  }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function fromProductJson(product) {
    product = product || {};
    var t = product.tags;
    var tags = Array.isArray(t) ? t : String(t || '').split(/,\s*/).filter(Boolean);
    if (tags.indexOf('nk-raffle') !== -1) return 'draw';
    if (tags.indexOf('nk-coming-soon') !== -1) return 'coming';
    return product.available === false ? 'sold' : 'available';
  }

  function saleStartFromTags(tags) {
    if (!Array.isArray(tags)) return null;
    var found = null;
    for (var i = 0; i < tags.length; i++) {
      if (typeof tags[i] !== 'string') return null;
      var match = /^(\d{4})(\d{2})(\d{2})-(?:ukiyoe|booketc)$/.exec(tags[i]);
      if (!match || match[0].length !== tags[i].length) continue;
      var iso = match[1] + '-' + match[2] + '-' + match[3] + 'T16:00:00Z';
      var date = new Date(iso);
      if (+match[1] < 1 || !Number.isFinite(date.getTime())
          || date.toISOString().slice(0, 10) !== iso.slice(0, 10)) return null;
      if (found !== null && found !== iso) return null;
      found = iso;
    }
    return found;
  }

  function parseTime(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.000)?Z$/.test(value)) return NaN;
    var time = Date.parse(value);
    if (!Number.isFinite(time) || new Date(time).toISOString().replace('.000Z', 'Z') !== value.replace('.000Z', 'Z')) return NaN;
    return time;
  }

  function updateCards(documentRef, now) {
    var cards = documentRef.querySelectorAll('[data-nk-state="coming"][data-nk-sale-starts]');
    Array.prototype.forEach.call(cards, function (card) {
      var time = parseTime(card.getAttribute('data-nk-sale-starts'));
      if (!Number.isFinite(time) || time > now) return;
      card.setAttribute('data-nk-state-phase', 'shortly');
      var labels = card.querySelectorAll('[data-nk-state-text]');
      Array.prototype.forEach.call(labels, function (label) {
        // 商品ページ内に並ぶ別商品の札まで変更しない。
        if (label.closest('[data-nk-state]') !== card) return;
        var text = label.getAttribute('data-nk-shortly-label') || card.getAttribute('data-nk-shortly-label');
        if (text) label.textContent = text;
      });
    });
  }

  // #290: 入荷予告の解禁は販売時刻 1:00:00 ぴったりに始まり、在庫の戻り（0→1）と印外しに数秒かかる。
  // 販売時刻に1回だけ読み直すと、まだ予告のままの画面で止まってしまうため、
  // 商品の状態が予告でなくなるまで短い間隔で見直してから読み直す。
  var RECHECK_INTERVAL_MS = 5000;
  var RECHECK_LIMIT_MS = 120000;

  function productJsonUrl(host, handle) {
    var routes = host.Shopify && host.Shopify.routes;
    var root = routes && typeof routes.root === 'string' && /^\/(?![\/\\])[^\s?#\\]*$/.test(routes.root) ? routes.root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function init(host) {
    if (host.__nkStateStarted) return;
    host.__nkStateStarted = true;
    var documentRef = host.document;
    var scheduled = Object.create(null);
    var clock = function () { return host.Date ? host.Date.now() : Date.now(); };

    function scheduleProduct(element) {
      var stamp = element.getAttribute('data-nk-sale-starts');
      var time = parseTime(stamp);
      var handle = element.getAttribute('data-nk-product-handle');
      // 既に時刻を過ぎて開いたページは再読み込みしない。
      if (!handle || !Number.isFinite(time) || time <= clock()) return;
      var key = 'nk-sale-reloaded:' + handle + ':' + stamp;
      if (scheduled[key]) return;
      scheduled[key] = true;
      try {
        if (host.sessionStorage.getItem(key)) return;
      } catch (error) {
        // 二重防止の記録が使えない端末は、自動再読み込みを行わない。
        return;
      }
      function reloadOnce() {
        try {
          if (host.sessionStorage.getItem(key)) return;
          host.sessionStorage.setItem(key, '1');
        } catch (error) { return; }
        host.location.reload();
      }
      function recheck(startedAt) {
        // 見直しの途中で別の経路が読み直していたら、それ以上は問い合わせない。
        try {
          if (host.sessionStorage.getItem(key)) return;
        } catch (error) { return; }
        var retry = function () {
          // 上限（2分）を過ぎたら、これまでどおり1回だけ読み直して終える。
          if (clock() - startedAt >= RECHECK_LIMIT_MS) { reloadOnce(); return; }
          host.setTimeout(function () { recheck(startedAt); }, RECHECK_INTERVAL_MS);
        };
        var request;
        try {
          request = host.fetch(productJsonUrl(host, handle), {
            cache: 'no-store', credentials: 'same-origin', headers: {Accept: 'application/json'}
          });
        } catch (error) { retry(); return; }
        Promise.resolve(request).then(function (response) {
          if (!response || !response.ok) throw new Error('product json');
          return response.json();
        }).then(function (product) {
          // 予告の印が外れた（買える・売り切れのどちらか）ら、正本の画面を読み直す。
          if (product && typeof product === 'object' && fromProductJson(product) !== 'coming') reloadOnce();
          else retry();
        }, retry);
      }
      function atSaleTime() {
        var delay = time - clock();
        if (delay > 0) {
          // 長い未来日でもタイマー上限を超えて連打しない。
          host.setTimeout(atSaleTime, Math.min(delay, 2147483647));
          return;
        }
        // 問い合わせの手段が無い端末は、従来どおり販売時刻に1回だけ読み直す。
        if (typeof host.fetch !== 'function') { reloadOnce(); return; }
        recheck(clock());
      }
      atSaleTime();
    }

    function scan() {
      updateCards(documentRef, clock());
      Array.prototype.forEach.call(documentRef.querySelectorAll('[data-nk-product-coming]'), scheduleProduct);
    }
    function start() {
      scan();
      documentRef.addEventListener('nk:cards-added', scan);
      documentRef.addEventListener('shopify:section:load', scan);
      documentRef.addEventListener('quickview:loaded', scan);
      host.addEventListener('pageshow', scan);
      host.setInterval(scan, 60000);
    }
    if (documentRef.readyState === 'loading') documentRef.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
  }

  return {fromProductJson: fromProductJson, saleStartFromTags: saleStartFromTags, updateCards: updateCards, init: init};
}));
